import type {NodeParameters} from "@cm/graph-v3"
import type {TemplateNodeDefinition} from "#template/template-node/types"
import type {GeometryValueData} from "#template/nodes/geometry-graph/interfaces"
import {GeometryGraphNode} from "#template/nodes/geometry-graph/common/geometry-graph-node"

export abstract class GeometryValueNode<out Parameters extends NodeParameters = NodeParameters> extends GeometryGraphNode<GeometryValueData, Parameters> {
    public abstract override get definition(): TemplateNodeDefinition<Parameters>

    protected override get evaluatedGeometryDataPrefix() {
        return "geometryValueData"
    }
}
